import React, { useRef, useState, useEffect } from "react";
import SignatureCanvas from "react-signature-canvas";
import { config } from "../../utils/config";
import { useDispatch } from "react-redux";
import { pushQueue } from "../../redux/processQueueSlice";
import { XMarkIcon } from "@heroicons/react/20/solid";
import {
  disabledIfFieldChecker,
  findDataInFields,
  resolveFieldValue,
} from "../../utils/helperFuctions";
import ErrorAlerts from "../Alerts/ErrorAlerts";
import axios from "axios";
import { getCookie } from "../../utils/cookieHandler";

const ESignature = ({
  label,
  name,
  handleChange,
  defaultValue,
  triggerProcess,
  buttonText,
  hideComponent,
  fields,
  dontShowTextWhen,
  disabled,
  disabledIfField,
  fieldsToValidate,
  validateField,
  formData,
  setErrors,
  callPopUp,
  secondButton,
  id,
  hideButton,
}) => {
  const [secondButtonLoading, setSecondButtonLoading] = useState(false);
  const checkIfIsHidden = () => {
    let isHidden = false;
    if (hideComponent != null) {
      hideComponent.forEach((component) => {
        const statement = findDataInFields(fields, component.if);

        if (component.equalsTo === statement) {
          isHidden = true;
        }
      });
    }
    return isHidden;
  };
  let dontShowText = false;
  if (dontShowTextWhen != null) {
    const value = findDataInFields(fields, dontShowTextWhen.field);
    if (value === dontShowTextWhen.isEqual) {
      dontShowText = true;
    }
  }

  const isHidden = checkIfIsHidden();
  const signatureCanvasRef = useRef(null);
  const [isDrawing, setIsDrawing] = useState(true);
  const dispatch = useDispatch();
  // Function to convert file to data URL
  const [signatureFile, setSignatureFile] = useState("");

  // Function to convert file to data URL
  const convertFileToDataURL = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };

  useEffect(() => {
    if (defaultValue && defaultValue instanceof FileList) {
      convertFileToDataURL(defaultValue[0])
        .then((dataUrl) => {
          setSignatureFile(dataUrl);
        })
        .catch((error) => {
          console.error("Error converting file to data URL:", error);
        });
    } else if (defaultValue && typeof defaultValue?.name === "string") {
      setSignatureFile(`${config.apiUrl}/assets/${defaultValue.name}`);
    }
  }, [defaultValue]);

  const handleSave = async (e) => {
    e.preventDefault();
    if (fieldsToValidate != null) {
      let newErrors = {};

      for (const field of fieldsToValidate) {
        const fieldError = await validateField(field, formData[field]);

        if (fieldError != null) {
          newErrors = { ...newErrors, [field]: fieldError };
        }
      }

      const isError = !Object.values(newErrors).every((error) => error === "");

      setErrors((prev) => ({
        ...prev,
        ...newErrors,
      }));
      if (isError) {
        if (callPopUp instanceof Function) {
          const sendErrors = Object.values(newErrors).filter((x) => x !== "");
          callPopUp({
            title: "",
            description: "",
            isError: true,
            showPopUp: true,
            hideCancel: true,
            children: (
              <ErrorAlerts title={"Validation Error"} list={sendErrors} />
            ),
          });
        }

        return;
      }
    }

    if (signatureCanvasRef.current.isEmpty()) {
      // if(defaultValue){
      //   if(typeof triggerProcess === "string"){
      //     dispatch(pushQueue({ key: triggerProcess, value: name}))
      //   }
      // }else{
      //   alert('Please provide a signature first.');
      // }
      if (typeof triggerProcess === "object") {
        triggerProcess.forEach((trigger) => {
          dispatch(pushQueue({ key: trigger, value: name }));
        });
      }
    } else {
      const signatureDataUrl = signatureCanvasRef.current.toDataURL();
      const signatureBlob = dataURLtoBlob(signatureDataUrl);
      // Create a File object from the Blob
      const signatureFile = new File([signatureBlob], "signature.png", {
        type: "image/png",
      });
      // Create a FileList and add the File object to it
      const fileList = new DataTransfer();
      fileList.items.add(signatureFile);
      setSignatureFile(signatureDataUrl);
      // Handle the signature file as needed (e.g., upload to backend, etc.)
      await handleChange({
        target: {
          name: name,
          value: signatureFile,
          files: fileList.files,
          type: "file",
        },
      });

      if (typeof triggerProcess === "object") {
        triggerProcess.forEach((trigger) => {
          dispatch(pushQueue({ key: trigger, value: name }));
        });
      }
    }
  };

  // Helper function to convert data URL to Blob
  const dataURLtoBlob = (dataURL) => {
    const parts = dataURL.split(";base64,");
    const contentType = parts[0].split(":")[1];
    const raw = window.atob(parts[1]);
    const rawLength = raw.length;
    const uInt8Array = new Uint8Array(rawLength);

    for (let i = 0; i < rawLength; ++i) {
      uInt8Array[i] = raw.charCodeAt(i);
    }

    return new Blob([uInt8Array], { type: contentType });
  };

  const handleStartDrawing = () => {
    setIsDrawing(false);
  };

  const handleEndDrawing = () => {
    setIsDrawing(true);
  };

  const handleClear = (e) => {
    e.preventDefault();
    signatureCanvasRef.current.clear();
    handleChange({
      target: {
        name: name,
        value: "removevaluefromdb",
      },
    });
    setSignatureFile(""); // Clear the signatureFile when clearing the canvas
  };

  const isFieldDisabled =
    disabledIfField != null
      ? disabled ||
        disabledIfFieldChecker(fields, {
          field: disabledIfField.field,
          valuesArray: disabledIfField.isEqual,
        })
      : disabled ?? false;

  return (
    <>
      {isHidden === true ? (
        <div></div>
      ) : (
        <div className="px-6">
          {label && (
            <label
              htmlFor={name}
              className="block text-sm font-medium leading-6 text-gray-900 text-left"
            >
              {label}
            </label>
          )}

          <div className="flex flex-col w-[300px]  mt-2">
            <div className="  h-[150px] max-w-2xl border border-gray-300 mb-4 relative">
              <SignatureCanvas
                ref={signatureCanvasRef}
                canvasProps={{ className: "signature-canvas w-full h-full" }}
                onBegin={() => {
                  if (isFieldDisabled === true) return;
                  handleStartDrawing();
                }}
                onEnd={() => {
                  if (isFieldDisabled === true) return;
                  handleEndDrawing();
                }}
              />
              {signatureFile && (
                <img
                  src={signatureFile}
                  alt="Signature Preview"
                  className="absolute inset-0 object-cover w-full h-full"
                />
              )}
              <button
                className={`absolute bg-[#7E22CE] text-gray-700 rounded ${
                  isDrawing ? "" : "opacity-50 cursor-not-allowed"
                }`}
                style={{
                  top: 5,
                  right: 5,
                  borderRadius: "50%",
                  cursor:
                    !isDrawing || isFieldDisabled ? "not-allowed" : "pointer",
                }}
                onClick={handleClear}
                disabled={!isDrawing || isFieldDisabled}
              >
                <XMarkIcon
                  className="h-5 w-5"
                  color="#fff"
                  aria-hidden="true"
                />
              </button>
            </div>
            {(hideButton == null || hideButton === false) && (
              <div className="space-y-2">
                <div className="w-full">
                  <button
                    style={{
                      cursor:
                        !isDrawing || isFieldDisabled
                          ? "not-allowed"
                          : "pointer",
                      opacity: !isDrawing || isFieldDisabled ? "15%" : "100%",
                    }}
                    className={`w-full px-4 py-2 bg-[#7E22CE] text-white rounded ${
                      isDrawing ? "" : "opacity-50 cursor-not-allowed"
                    }`}
                    onClick={handleSave}
                    disabled={!isDrawing || isFieldDisabled}
                  >
                    {dontShowText === true
                      ? "Save signature"
                      : buttonText || "Save"}
                  </button>
                </div>
                {secondButton != null && (
                  <div className="w-full">
                    <button
                      style={{
                        cursor:
                          !isDrawing || isFieldDisabled
                            ? "not-allowed"
                            : "pointer",
                        opacity: !isDrawing || isFieldDisabled ? "15%" : "100%",
                      }}
                      className={`w-full px-4 py-2 bg-[#7E22CE] text-white rounded flex justify-center ${
                        isDrawing ? "" : "opacity-50 cursor-not-allowed"
                      }`}
                      onClick={async (e) => {
                        e.preventDefault();
                        if (fieldsToValidate != null) {
                          let newErrors = {};

                          for (const field of fieldsToValidate) {
                            const fieldError = await validateField(
                              field,
                              formData[field]
                            );

                            if (fieldError != null) {
                              newErrors = { ...newErrors, [field]: fieldError };
                            }
                          }

                          const isError = !Object.values(newErrors).every(
                            (error) => error === ""
                          );

                          setErrors((prev) => ({
                            ...prev,
                            ...newErrors,
                          }));
                          if (isError) {
                            if (callPopUp instanceof Function) {
                              const sendErrors = Object.values(
                                newErrors
                              ).filter((x) => x !== "");
                              callPopUp({
                                title: "",
                                description: "",
                                isError: true,
                                showPopUp: true,
                                hideCancel: true,
                                children: (
                                  <ErrorAlerts
                                    title={"Validation Error"}
                                    list={sendErrors}
                                  />
                                ),
                              });
                            }

                            return;
                          }
                        }
                        const data = {};

                        for (const [key, value] of Object.entries(
                          secondButton.body
                        )) {
                          data[key] = resolveFieldValue(key, value, fields, id);
                        }
                        const requiredFields = Object.values(data);

                        // Check if all required fields are non-null and not undefined
                        const allFieldsValid = requiredFields.every(
                          (val) => val !== null && val !== undefined
                        );

                        if (allFieldsValid) {
                          const formData = new FormData();
                          for (const [key, value] of Object.entries(data)) {
                            formData.append(key, value);
                          }

                          // Convert FormData to query string
                          const queryString = new URLSearchParams(
                            formData
                          ).toString();

                          const urlWithParams = `${config.apiUrl}${secondButton.url}?${queryString}`;
                          setSecondButtonLoading(true);
                          const res = await fetch(urlWithParams, {
                            method: "GET",
                            headers: {
                              Authorization: `Bearer ${getCookie("_AT")}`,
                            },
                          });

                          const result = await res.json();

                          if (
                            callPopUp instanceof Function &&
                            result.success === true
                          ) {
                            callPopUp({
                              title: "Email Sent Successfully",
                              description:
                                "The contract has been sent to the customer's email address.",
                              showPopUp: true,
                              hideCancel: true,
                            });
                          }

                          setSecondButtonLoading(false);
                          if (result.error != null) {
                            if (callPopUp instanceof Function) {
                              callPopUp({
                                title: "Error ",
                                description: "Contract not generated.",
                                isError: true,
                                showPopUp: true,
                                hideCancel: true,
                              });
                            }
                          }
                        }
                      }}
                      disabled={!isDrawing || isFieldDisabled}
                    >
                      {secondButtonLoading === true ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="animate-spin h-5 w-5"
                          viewBox="0 0 24 24"
                          strokeWidth={1.5}
                          stroke="#ffffff"
                          fill="none"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M21 12a9 9 0 1 1-6.219-8.56" />
                        </svg>
                      ) : (
                        secondButton.text
                      )}
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default ESignature;
